import { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { toast } from 'sonner';

export default function BackupExportCard({ summary }) {
  const [downloading, setDownloading] = useState(false);
  const [received, setReceived] = useState(0);

  const totalDocs = summary ? Object.values(summary.collections).reduce((a, c) => a + c.count, 0) : 0;

  const handleExport = async () => {
    setDownloading(true);
    setReceived(0);
    try {
      const res = await api.get('/admin/backup/export', {
        responseType: 'blob',
        timeout: 0,
        onDownloadProgress: (e) => setReceived(e.loaded),
      });
      const disposition = res.headers['content-disposition'] || '';
      const match = disposition.match(/filename="?([^"]+)"?/);
      const filename = match ? match[1] : `backup-andreacaruso-${new Date().toISOString().slice(0, 10)}.json`;
      const url = URL.createObjectURL(res.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success(`Backup scaricato (${(res.data.size / 1024 / 1024).toFixed(1)} MB)`);
    } catch (e) {
      toast.error('Errore durante l\'esportazione del backup');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Card data-testid="backup-export-card">
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2"><Download size={18} /> Esporta backup</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-sm text-muted-foreground">
          Scarica un unico file <code>.json</code> con tutti i contenuti: progetti, foto (dati immagine inclusi), servizi,
          recensioni, prenotazioni, leads, impostazioni e account admin. Attualmente {totalDocs} elementi.
        </p>
        {downloading && (
          <div className="space-y-1">
            <Progress value={undefined} className="h-2" />
            <p className="text-xs text-muted-foreground">Preparazione in corso... {(received / 1024 / 1024).toFixed(1)} MB ricevuti</p>
          </div>
        )}
        <Button onClick={handleExport} disabled={downloading} className="w-full" data-testid="backup-export-btn">
          {downloading ? <Loader2 size={16} className="mr-2 animate-spin" /> : <Download size={16} className="mr-2" />}
          {downloading ? 'Esportazione...' : 'Scarica backup completo'}
        </Button>
      </CardContent>
    </Card>
  );
}
